import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';

@Component({
  selector: 'app-prelogin',
  template: '',
  styles: ['']
})
export class PreLoginComponent implements OnInit {
  loginDto: any; // Aquí se guardará el objeto parseado

  constructor(private route: ActivatedRoute,private router: Router) { }

  ngOnInit(): void {
    // Se suscribe a los parámetros de la URL
    this.route.queryParams.subscribe(params => {
      const encodedLoginDto = params['loginDto'];
      if (encodedLoginDto) {
        try {
          // Decodifica la cadena en base64
          const decodedString = atob(encodedLoginDto);
          // Convierte el string JSON en un objeto
          this.loginDto = JSON.parse(decodedString);
        //   console.log('Objeto loginDto:', this.loginDto);


          localStorage.setItem('IES-AC-TK', this.loginDto['token']);
          localStorage.setItem('IES-AC-RTK', this.loginDto['refreshToken']);
            this.router.navigate(['/home']);
        } catch (error) {
          console.error('Error al decodificar o parsear el loginDto:', error);
        }
      } else {
        console.warn('No se encontró el parámetro loginDto en la URL');
      }
    });
  }
}
